module.exports = __webpack_public_path__ + "static/media/add-blue.f13d3a67.svg";